import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { async } from "@angular/core/testing";
import { Observable } from "rxjs";
import { AuthService } from "src/app/auth/auth.service";
import { JwtObj, PublicJwtObj } from "src/app/auth/jwt-obj";
import { EMPTY } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes("restcountries")) return next.handle(req);

    const publicJwtObj: PublicJwtObj = this.authService.getPublicJwt();

    const jwtObj: JwtObj = this.authService.fetchJwt();
    if (jwtObj) {
      if (Date.now() > jwtObj.expiration) {
        this.authService.signOut();
        return EMPTY;
      }
    }

    const modified = req.clone({
      headers: req.headers
        .append(
          "x-dpi-auth",
          jwtObj !== null
            ? jwtObj.jwt
            : publicJwtObj !== null
            ? publicJwtObj.jwt
            : "123456"
        )
        .append("Set-Cookie", "promo_shown=1; Max-Age=2600000; Secure"),
    });
    return next.handle(modified);
  }
}
